import { t } from "@/i18n-js/instance";

export const EMAIL_CORE_COLORS = [
  {
    name: "theme-email-color-1",
    title: t("builder_ui.theme_configuration.email_colors.primary"),
    variable: "theme-email-color-1",
  },
  {
    name: "theme-email-color-2",
    title: t("builder_ui.theme_configuration.email_colors.secondary"),
    variable: "theme-email-color-2",
  },
  {
    name: "theme-email-color-3",
    title: t("builder_ui.theme_configuration.email_colors.background"),
    variable: "theme-email-color-3",
  },
  {
    name: "theme-email-color-4",
    title: t("builder_ui.theme_configuration.email_colors.text"),
    variable: "theme-email-color-4",
  },
  {
    name: "theme-email-color-5",
    title: t("builder_ui.theme_configuration.email_colors.accent"),
    variable: "theme-email-color-5",
  },
  {
    name: "theme-email-color-6",
    title: t("builder_ui.theme_configuration.email_colors.button"),
    variable: "theme-email-color-6",
  },
];
